import React from 'react';

const SocialPostYouTube = ({ model }) => {
    return (
        <div className='social-post__body--youtube' dangerouslySetInnerHTML={{ __html: model.body }}>
        </div>
    );
};

export default SocialPostYouTube;
